export default "/assets/images/awards-img-01-lg.svg?c2b3f7964914be61825e7647c2917cb2";